import React, { useMemo, useState } from "react";
import { useListings } from "../../../hooks/listing/useListings";
import ProductGrid from "../../../components/listing/product-card/ProductGrid";
import "./ThanhLyPage.css";

import SearchAndCategorySection from "../../../components/listing/thanhly/SearchAndCategorySection";

const ThanhLyPage = () => {
  const { displayedListings, loading, error, hasMore, loadMore } =
    useListings();

  const [searchText, setSearchText] = useState("");
  const [provinceId, setProvinceId] = useState("");

  
  const filtered = useMemo(() => {
    // `allListings` is removed from useListings hook, so we only use displayedListings
    const base = displayedListings;
    return base.filter((item) => {
      const title = (item.title || item.Title || "").toLowerCase();
      const itemProvinceId = String(item.ProvinceID || "");

      const okSearch = searchText
        ? title.includes(searchText.toLowerCase())
        : true;
      const okProvince = provinceId
        ? itemProvinceId === provinceId
        : true;

      return okSearch && okProvince;
    });
  }, [
    displayedListings,
    searchText,
    provinceId,
  ]);

  return (
    <div className="thanhly-page-container">
      {/* Đây chính là khối header chỉ có ảnh nền */}
      <div
        className="hero-section"
        style={{
          backgroundImage: `url('/images/nen-cate.jpg')`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
      >

      </div>

      <SearchAndCategorySection
        searchText={searchText}
        provinceId={provinceId}
        onSearchTextChange={setSearchText}
        onProvinceChange={setProvinceId}
      />

      <section className="product-section">
        <h2 className="section-title">Sản phẩm thanh lý</h2>
        {loading && filtered.length === 0 && (
          <p className="status-text">Đang tải...</p>
        )}
        {error && <p className="status-text error-text">{error}</p>}
        <ProductGrid listings={filtered} />

        <div className="load-more-container">
          {hasMore && (
            <button
              onClick={loadMore}
              disabled={loading}
              className="load-more-btn"
            >
              {loading ? "Đang tải..." : "Xem thêm"}
            </button>
          )}
          {!hasMore && filtered.length > 0 && (
            <p className="status-text">Bạn đã xem hết tin đăng.</p>
          )}
        </div>
      </section>
    </div>
  );
};

export default ThanhLyPage;